export const APP_VERSION = '1.0.0';
export const ENV = process.env.REACT_APP_ENV || 'staging';

export const FRONTEND_URL = process.env.REACT_APP_FRONT_URL || 'https://myaccountguard.com/';

export const BACKEND_URL = process.env.REACT_APP_API_URL || 'https://myaccountguard.com/api/';
export const ROWS_PER_PAGE =  10

export const PYTHON_BACKEND_URL = process.env.REACT_APP_PYTHON_BACKEND_URL || 'https://myaccountguard.com/api/verify/';

export const WS_URL = process.env.REACT_APP_WS_URL || 'wss://myaccountguard.com/api/verify/ws/video_process';

